import { CaseStudyContent } from './models/case-study-content';

export const isCaseStudy = (caseStudy: CaseStudyContent | unknown): caseStudy is CaseStudyContent => {
  return Boolean(caseStudy && typeof caseStudy === 'object' && '_type' in caseStudy && caseStudy._type === 'caseStudy');
};
